// KirchHero — Logo using the official lion-head + wordmark image
// LogoFull = full lion + wordmark image (gold)
// LogoIcon = just the lion-head image (square-ish for favicons / cart-drawer)
// LogoMark = same as LogoFull but smaller

const LOGO_SRC = "/logo-kirchero.png";

export function LogoFull({ height = 36, className = "", alt = "KirchHero" }) {
  return (
    <img
      src={LOGO_SRC}
      alt={alt}
      height={height}
      style={{ height, width: "auto", display: "block" }}
      className={className}
      data-testid="kirchero-logo"
      draggable={false}
    />
  );
}

export function LogoMark({ size = 40, className = "" }) {
  return (
    <img
      src={LOGO_SRC}
      alt="KirchHero"
      style={{ height: size, width: "auto", display: "block" }}
      className={className}
      draggable={false}
    />
  );
}

export function LogoIcon({ size = 24, className = "" }) {
  // Crop tightly to lion head — lion sits in the left ~35% of the image
  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        overflow: "hidden",
        position: "relative",
        display: "inline-block",
      }}
    >
      <img
        src={LOGO_SRC}
        alt="KirchHero"
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          height: size,
          width: "auto",
          objectFit: "cover",
          objectPosition: "left center",
        }}
        draggable={false}
      />
    </div>
  );
}

export default LogoFull;
